'use client'

import { useEffect } from 'react'

import { useGraftcodeOnboardingStore } from '@apps/graftcode-onboarding/stores/graftcode-onboarding.store'

import { GRAFTCODE_ONBOARDING_PHASE } from '../../graftcode-onboarding.const'
import { GRAFTCODE_ONBOARDING_TEST_IDS } from '../../graftcode-onboarding-test-ids.const'
import { useGraftcodeOnboardingHydrate, useGraftcodeOnboardingRequiredWizard } from '../../hooks'
import { GraftcodeOnboardingWizard } from '../GraftcodeOnboardingWizard'

import { useGraftcodeOnboardingDevAutoOpen } from './hooks'

type GraftcodeOnboardingProps = {
  enabled: boolean
}

export function GraftcodeOnboarding({ enabled }: GraftcodeOnboardingProps) {
  const phase = useGraftcodeOnboardingStore((state) => state.phase)

  useGraftcodeOnboardingHydrate()
  useGraftcodeOnboardingRequiredWizard(enabled)
  useGraftcodeOnboardingDevAutoOpen(enabled)

  useEffect(() => {
    if (!enabled || phase !== GRAFTCODE_ONBOARDING_PHASE.wizard) {
      document.body.classList.remove('graftcode-ob-open')
      return
    }
    document.body.classList.add('graftcode-ob-open')
    return () => {
      document.body.classList.remove('graftcode-ob-open')
    }
  }, [enabled, phase])

  if (!enabled || phase !== GRAFTCODE_ONBOARDING_PHASE.wizard) {
    return null
  }

  return (
    <div data-testid={GRAFTCODE_ONBOARDING_TEST_IDS.shell}>
      <GraftcodeOnboardingWizard />
    </div>
  )
}
